<template>
    <b-button @click="addFile" size="sm" :variant="variant"  :title="showToolTip ? tooltip : ''">
      <i :class="icon"></i>{{ text === null ? '' : ' ' + text }}
      <input ref="uploader" class="d-none" type="file" accept="image/*;capture=camera" @change="onFileChanged"/>
    </b-button>
</template>

<script>

export default ({
  name: "button-add-file",

  props: {    
    variant: {
      type: String,
      default: 'warning'
    },
    tooltip: {
      type: String,
      default: 'Добавить файл'
    },
    icon: {
      type: String,
      default: "fa fa-plus"
    },
    text: {
      type: String,
      default: null
    },
  },

  data: function() {
    return {
      isSelecting: false,
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
  
  methods: {
    addFile() {
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
          this.isSelecting = false
      }, { once: true });
      
      this.$refs.uploader.value = null
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      this.$emit('onAddFile', e.target.files[0])

    }
  }
})
</script>
